import { Controller } from "@hotwired/stimulus"

// Toggles a panel open/closed without sessionStorage.
// Initial state comes from the HTML attribute data-disclosure-open-value.
// Use data-disclosure-open-value="true" to start open (e.g. on form validation errors).
export default class extends Controller {
  static targets = ["panel", "icon"]
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", !this.openValue)
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-45", this.openValue)
    }
  }
}
